module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/store_nara-65761390f0093a6774c3f3afbd621ffb.jpg";